import { Injectable } from "@angular/core";
import {  Subject } from "rxjs";

@Injectable()
export class MessageDisplayLoaderService {
  showMessageObs: Subject<boolean> = new Subject<boolean>();
  messageObs: Subject<string> = new Subject<string>();

  toggleShowMessage(toggleValue: boolean) {
    this.showMessageObs.next(toggleValue);
  }

  updateMessage(message: string) {
    this.messageObs.next(message);
  }
}
